import type { Template } from "@/types";

export const MFS: Template[] = [
    {
        id: "mf-01",
        name: "ARMADALE",
        albumType: "MF",
        thumbnail: "/thumbnails/MF/AR_1.00/armadale.png",
        size: [865, 865],
        style: {},
        slots: [
            { id: "1", x: 63, y: 64, width: 364, height: 363, rotation: 0, imageRotation: 0 },
            { id: "2", x: 438, y: 64, width: 364, height: 176, rotation: 0, imageRotation: 0 },
            { id: "3", x: 438, y: 251, width: 177, height: 176, rotation: 0, imageRotation: 0 },
            { id: "4", x: 626, y: 251, width: 176, height: 176, rotation: 0, imageRotation: 0 },
            { id: "5", x: 63, y: 438, width: 177, height: 176, rotation: 0, imageRotation: 0 },
            { id: "6", x: 251, y: 438, width: 176, height: 176, rotation: 0, imageRotation: 0 },
            { id: "7", x: 63, y: 625, width: 364, height: 176, rotation: 0, imageRotation: 0 },
            { id: "8", x: 438, y: 438, width: 364, height: 363, rotation: 0, imageRotation: 0 },            
        ],
     
    },

    {
        id: "mf-02",
        name: "BRIGHTON",
        albumType: "MF",
        thumbnail: "/thumbnails/MF/AR_1.00/brighton.png",
        size: [865, 865],
        style: {},
        slots: [
            { id: "1", x: 63, y: 64, width: 474, height: 737, rotation: 0, imageRotation: 0 },
            { id: "2", x: 547, y: 64, width: 255, height: 176, rotation: 0, imageRotation: 0 },
            { id: "3", x: 547, y: 251, width: 255, height: 176, rotation: 0, imageRotation: 0 },
            { id: "4", x: 547, y: 438, width: 255, height: 176, rotation: 0, imageRotation: 0 },
            { id: "5", x: 547, y: 625, width: 255, height: 176, rotation: 0, imageRotation: 0 },          
        ],
     
     
    },

    {
        id: "mf-03",
        name: "BRUNSWICK",
        albumType: "MF",
        thumbnail: "/thumbnails/MF/AR_1.00/brunswick.png",
        size: [865, 865],
        style: {},
        slots: [
            { id: "1", x: 63, y: 64, width: 364, height: 363, rotation: 0, imageRotation: 0 },
            { id: "2", x: 438, y: 64, width: 364, height: 363, rotation: 0, imageRotation: 0 },
            { id: "3", x: 63, y: 438, width: 364, height: 363, rotation: 0, imageRotation: 0 },
            { id: "4", x: 438, y: 438, width: 364, height: 363, rotation: 0, imageRotation: 0 }
        ],
      
    },

    {
        id: "mf-04",
        name: "HAWTHORN",
        albumType: "MF",
        thumbnail: "/thumbnails/MF/AR_1.00/hawthorn.png",
        size: [865, 865],
        style: {},
        slots: [
            { id: "1", x: 63, y: 64, width: 239, height: 239, rotation: 0, imageRotation: 0 },
            { id: "2", x: 313, y: 64, width: 239, height: 239, rotation: 0, imageRotation: 0 },
            { id: "3", x: 563, y: 64, width: 239, height: 239, rotation: 0, imageRotation: 0 },
            { id: "4", x: 63, y: 314, width: 239, height: 238, rotation: 0, imageRotation: 0 },
            { id: "5", x: 313, y: 314, width: 239, height: 238, rotation: 0, imageRotation: 0 },
            { id: "6", x: 563, y: 314, width: 239, height: 238, rotation: 0, imageRotation: 0 },
            { id: "7", x: 63, y: 563, width: 239, height: 238, rotation: 0, imageRotation: 0 },
            { id: "8", x: 313, y: 563, width: 239, height: 238, rotation: 0, imageRotation: 0 },
            { id: "9", x: 563, y: 563, width: 239, height: 238, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "mf-05",
        name: "LILYDALE",
        albumType: "MF",
        thumbnail: "/thumbnails/MF/AR_1.00/lilydale.png",
        size: [865, 865],
        style: {},
        slots: [
            { id: "1", x: 63, y: 64, width: 177, height: 176, rotation: 0, imageRotation: 0 },
            { id: "2", x: 251, y: 64, width: 177, height: 176, rotation: 0, imageRotation: 0 },
            { id: "3", x: 439, y: 64, width: 176, height: 176, rotation: 0, imageRotation: 0 },
            { id: "4", x: 626, y: 64, width: 176, height: 176, rotation: 0, imageRotation: 0 },
            { id: "5", x: 63, y: 251, width: 177, height: 176, rotation: 0, imageRotation: 0 },
            { id: "6", x: 251, y: 251, width: 177, height: 176, rotation: 0, imageRotation: 0 },
            { id: "7", x: 439, y: 251, width: 176, height: 176, rotation: 0, imageRotation: 0 },
            { id: "8", x: 626, y: 251, width: 176, height: 176, rotation: 0, imageRotation: 0 },
            { id: "9", x: 63, y: 438, width: 177, height: 176, rotation: 0, imageRotation: 0 },
            { id: "10", x: 251, y: 438, width: 177, height: 176, rotation: 0, imageRotation: 0 },
            { id: "11", x: 439, y: 438, width: 176, height: 176, rotation: 0, imageRotation: 0 },
            { id: "12", x: 626, y: 438, width: 176, height: 176, rotation: 0, imageRotation: 0 },
            { id: "13", x: 63, y: 625, width: 177, height: 176, rotation: 0, imageRotation: 0 },
            { id: "14", x: 251, y: 625, width: 177, height: 176, rotation: 0, imageRotation: 0 },
            { id: "15", x: 439, y: 625, width: 176, height: 176, rotation: 0, imageRotation: 0 },
            { id: "16", x: 626, y: 625, width: 176, height: 176, rotation: 0, imageRotation: 0 }
        ],

    },


    {
        id: "mf-06",
        name: "MELBOURNE",
        albumType: "MF",
        thumbnail: "/thumbnails/MF/AR_1.00/melbourne.png",
        size: [865, 865],
        style: {},
        slots: [
            { id: "1", x: 63, y: 64, width: 472, height: 737, rotation: 0, imageRotation: 0 },
            { id: "2", x: 546, y: 64, width: 256, height: 363, rotation: 0, imageRotation: 0 },
            { id: "3", x: 546, y: 438, width: 256, height: 363, rotation: 0, imageRotation: 0 }
        ],
    
    },

    {
        id: "mf-07",
        name: "RICHMOND",
        albumType: "MF",
        thumbnail: "/thumbnails/MF/AR_1.00/richmond.png",
        size: [865, 865],
        style: {},
        slots: [
            { id: "1", x: 82, y: 66, width: 504, height: 733, rotation: 0, imageRotation: 0 },
            { id: "2", x: 597, y: 66, width: 187, height: 237, rotation: 0, imageRotation: 0 },
            { id: "3", x: 597, y: 314, width: 187, height: 237, rotation: 0, imageRotation: 0 },
            { id: "4", x: 597, y: 562, width: 187, height: 237, rotation: 0, imageRotation: 0 }
        ],
      
    },

    {
        id: "mf-08",
        name: "SORRENTO",
        albumType: "MF",
        thumbnail: "/thumbnails/MF/AR_1.00/sorrento.png",
        size: [865, 865],
        style: {},
        slots: [
            { id: "1", x: 68, y: 66, width: 730, height: 479, rotation: 0, imageRotation: 0 },
            { id: "2", x: 68, y: 556, width: 236, height: 243, rotation: 0, imageRotation: 0 },
            { id: "3", x: 315, y: 556, width: 236, height: 243, rotation: 0, imageRotation: 0 },
            { id: "4", x: 562, y: 556, width: 236, height: 243, rotation: 0, imageRotation: 0 }
        ],
      
    },

    {
        id: "mf-09",
        name: "THORNTON",
        albumType: "MF",
        thumbnail: "/thumbnails/MF/AR_1.00/thornton.png",
        size: [865, 865],
        style: {},
        slots: [
            { id: "1", x: 68, y: 66, width: 174, height: 175, rotation: 0, imageRotation: 0 },
            { id: "2", x: 254, y: 66, width: 174, height: 175, rotation: 0, imageRotation: 0 },
            { id: "3", x: 440, y: 66, width: 173, height: 175, rotation: 0, imageRotation: 0 },
            { id: "4", x: 625, y: 66, width: 173, height: 175, rotation: 0, imageRotation: 0 },
            { id: "5", x: 68, y: 253, width: 174, height: 174, rotation: 0, imageRotation: 0 },
            { id: "6", x: 625, y: 253, width: 173, height: 174, rotation: 0, imageRotation: 0 },
            { id: "7", x: 68, y: 439, width: 174, height: 174, rotation: 0, imageRotation: 0 },
            { id: "8", x: 625, y: 439, width: 173, height: 174, rotation: 0, imageRotation: 0 },
            { id: "9", x: 68, y: 625, width: 174, height: 174, rotation: 0, imageRotation: 0 },
            { id: "10", x: 254, y: 625, width: 174, height: 174, rotation: 0, imageRotation: 0 },
            { id: "11", x: 440, y: 625, width: 173, height: 174, rotation: 0, imageRotation: 0 },
            { id: "12", x: 625, y: 625, width: 173, height: 174, rotation: 0, imageRotation: 0 },
            { id: "13", x: 254, y: 253, width: 359, height: 360, rotation: 0, imageRotation: 0 }
        ],      
    },

  
];
